import getLevel from '../util/get-level';

function getDefaultRoutes(entity) {
  const lowerCased = entity.toLowerCase();

  return {
    Customer: `customer/:customer_id/${lowerCased}`,
    Account: `customer/:customer_id/account/:account_id/${lowerCased}`,
    Campaign: `customer/:customer_id/account/:account_id/campaign/:campaign_id/${lowerCased}`,
    AdGroup: `customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/${lowerCased}`,
  };
}


export default function getDefaultRoute(entity, {
  CampaignId,
  AdGroupId,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  return getDefaultRoutes(entity)[level];
}

const constants = {
  Complex: 'Complex',
  Deleted: 'Deleted',
};

function entityToPath(entity, serverContext = {}) {
  const { DynamicPermissions = {} } = serverContext;
  const entityPathMap = {
    Account: 'accounts/performance',
    Ad: 'ads',
    AdExtensionAssociation: constants.Complex,
    AdGroup: 'adgroups',
    AdGroupAudienceAssociation: 'audiences',
    AdGroupCriterion: constants.Complex,
    // The blank suffix is by design, see dimension/grid/ageGender/ageGender-grid-config.es
    'AgeAndGender ': 'reports-v4/create/ageandgenderreport',
    AssetLink: 'assets',
    AssetWithBIData: 'assets-report',
    AudienceAssociation: 'audiences',
    AutomatedExtension: 'extensions/automated',
    Budget: 'sharedbudgets',
    CallForwardingDetail: 'reports-v4/create/callforwarddetailreport',
    Campaign: 'campaigns',
    CampaignCriterion: constants.Complex,
    ChangeHistoryDetailReport: 'changehistory',
    DestinationUrl: 'landingpages',
    DimensionRow: constants.Complex,
    DomainCategory: constants.Deleted, // DSA category page is removed in new UI
    DsaSearchTerm: 'dynamicadtargets/searchterms',
    DsaTarget: 'dynamicadtargets/targets',
    Folder: 'assetlibrary/performance',
    Geographic: 'geographicreport',
    Hotel: 'hotelcenter/overview/hotelidgrid',
    HotelGroup: 'hotelcenter/overview/hotelgroupgrid',
    Keyword: 'keywords',
    NegativeAdGroupCriterion: constants.Complex,
    NegativeAdGroupDsaTarget: 'dynamicadtargets/negative/adgroup',
    NegativeCampaignCriterion: constants.Complex,
    NegativeCampaignDsaTarget: 'dynamicadtargets/negative/campaign',
    PortfolioBidStrategy: DynamicPermissions.DataExclusions ? 'bidstrategies/portfoliobidstrategy' : 'portfoliobidstrategy',
    ProductGroup: constants.Complex,
    PublisherWebsite: 'reports-v4/create/weburlreport',
    ResponsiveSearchAdInstance: 'combinations',
    SearchTerm: 'searchterms',
    SearchTerms: 'reports-v4/create/searchtermreport',
    ShoppingBrand: 'reports-v4/create/productdimensionreport',
    ShoppingCategory: 'reports-v4/create/productdimensionreport',
    ShoppingItemId: 'reports-v4/create/productdimensionreport',
    ShoppingProductType: 'reports-v4/create/productdimensionreport',
    ShoppingStoreId: 'reports-v4/create/productdimensionreport',
    SubAccount: 'hotelcenter/overview/hotelsubaccountgrid',
    TimeDate: 'adscheduledate',
    TimeDayOfWeek: 'adscheduleday',
    TimeHourOfDay: 'adschedulehour',
    TimeMonth: 'adschedulemonth',
    TimeQuarter: 'adschedulequarter',
    TimeWeek: 'adscheduleweek',
    TimeYear: 'adscheduleyear',
    UserLocations: 'userlocationreport',
  };
  return entityPathMap[entity];
}


export function getDefaultRouteForNewUI({
  getUrlSearch,
  entity,
  selection: {
    CampaignId,
    AdGroupId,
    AdId,
  },
  serverContext,
}) {
  const path = entityToPath(entity, serverContext);
  const search = getUrlSearch({
    campaignId: CampaignId,
    adGroupId: AdGroupId,
    adId: AdId,
    entity,
  });

  return `${path}${search}`;
}

